// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__NK-sU","footer":"ModalFilter_footer__35LGx"};